export enum LogsBackupType {
    NOTIFICATION = 'NOTIFICATION',
    CHECKOUT = 'CHECKOUT',
}

export enum LogsBackupHttpMethod {
    GET = 'GET',
    POST = 'POST',
}

export enum LogsBackupTableAction {
    OPEN_DETAILS = 'OPEN_DETAILS',
    REPROCESS = 'REPROCESS',
}
